export enum InsuranceCovered {
	Yes = 'YES',
	No = 'NO',
	Warning = 'WARNING',
}
